/* ==========================================================
   CUSTOM.JS – SHOPIFY
   Author: Prince Rohilla
   Description: All custom scripts arranged & optimized
========================================================== */


/* ==========================================================
   DOM READY
========================================================== */
document.addEventListener('DOMContentLoaded', function () {

  console.log('✅ Custom JS Loaded');


  /* ======================================================
     1️⃣ SIZE CHART – INCH ⇄ CM CONVERSION
  ====================================================== */

  // const measurementCells = document.querySelectorAll('#sizeTable tbody td[data-inch]');

  // window.switchTab = function (unit) {
  //   if (unit === 'cm') {
  //     document.getElementById('inchesTab')?.classList.remove('active');
  //     document.getElementById('cmTab')?.classList.add('active');
  //     convertToCm();
  //   } else {
  //     document.getElementById('cmTab')?.classList.remove('active');
  //     document.getElementById('inchesTab')?.classList.add('active');
  //     resetToInches();
  //   }
  // };

  // function convertToCm() {
  //   measurementCells.forEach(cell => {
  //     const inch = parseFloat(cell.dataset.inch);
  //     if (!isNaN(inch)) {
  //       cell.textContent = (inch * 2.54).toFixed(1);
  //     }
  //   });
  // }

  // function resetToInches() {
  //   measurementCells.forEach(cell => {
  //     cell.textContent = cell.dataset.inch;
  //   });
  // }


  /* ======================================================
     2️⃣ COLLECTION PAGE – IMAGE HOVER SEQUENCE
  ====================================================== */

  document.querySelectorAll('.grid-product__link[data-hover-images]').forEach(link => {

    const images = link.dataset.hoverImages.split('||');
    const mainImage = link.querySelector('[data-main-product-image]');
    if (!mainImage || images.length <= 1) return;

    let index = 1;
    let timer;
    const original = images[0];

    const start = () => {
      mainImage.src = images[index];
      index++;
      if (images[index]) {
        timer = setTimeout(start, 1000);
      }
    };

    link.addEventListener('mouseenter', () => {
      clearTimeout(timer);
      index = 1;
      start();
    });

    link.addEventListener('mouseleave', () => {
      clearTimeout(timer);
      mainImage.src = original;
    });

  });


  /* ======================================================
     3️⃣ COLLECTION PAGE – 4 IMAGE AUTO SWAP
  ====================================================== */

  document.addEventListener('mouseenter', function (e) {
    const gallery = e.target.closest('.product-image-gallery');
    if (!gallery) return;

    clearInterval(gallery.cycle);
    const images = gallery.querySelectorAll('.product-gallery-image');
    if (images.length <= 1) return;

    let i = 0;
    images.forEach((img, idx) => img.classList.toggle('is-active', idx === 0));

    gallery.cycle = setInterval(() => {
      images[i].classList.remove('is-active');
      i = (i + 1) % images.length;
      images[i].classList.add('is-active');
    }, 2000);
  }, true);

  document.addEventListener('mouseleave', function (e) {
    const gallery = e.target.closest('.product-image-gallery');
    if (!gallery?.cycle) return;

    clearInterval(gallery.cycle);
    gallery.cycle = null;

    gallery.querySelectorAll('.product-gallery-image')
      .forEach((img, i) => img.classList.toggle('is-active', i === 0));
  }, true);


  /* ======================================================
     4️⃣ PRODUCT PAGE – VARIANT PREORDER LOGIC
  ====================================================== */

  if (document.body.classList.contains('template-product')) {

    const variantSelector = document.querySelector('[name="id"]');
    const buyBtn = document.getElementById('prouductpagebuybutton');
    const stockScarcity = document.querySelector('.stock-scaracity');

    const variantPreorderMap = window.variantPreorderMap || {};

    const togglePreorderUI = () => {
      const id = variantSelector?.value;
      if (!id) return;

      const isPreorder = variantPreorderMap[id] === 'Preorder';

      if (buyBtn) buyBtn.style.display = isPreorder ? 'none' : 'block';
      if (stockScarcity) stockScarcity.style.display = isPreorder ? 'none' : 'block';
    };

    variantSelector?.addEventListener('change', togglePreorderUI);
    togglePreorderUI();
  }


  /* ======================================================
     5️⃣ MAX INVENTORY MESSAGE HIDE ON PREORDER
  ====================================================== */

  const form = document.querySelector('product-form, form[action="/cart/add"]');
  const msg = document.querySelector('.max_inv_msg');
  const productJson = document.querySelector('[data-product-json], script[id^="ProductJson-"]');

  if (form && msg && productJson) {

    const product = JSON.parse(productJson.textContent);

    const updateMsg = () => {
      const id = form.querySelector('[name="id"]:checked, [name="id"] option:checked')?.value;
      const variant = product.variants.find(v => v.id == id);
      msg.classList.toggle('is-hidden', variant?.metafields?.custom?.preorder_value === 'Preorder');
    };

    form.addEventListener('change', updateMsg);
    updateMsg();
  }


  /* ======================================================
     6️⃣ PDP – AUTO OPEN 2ND TAB
  ====================================================== */

  const blocks = document.querySelectorAll('.product-block-custom-style .fjbxnv');

  if (blocks.length > 1) {
    const tab = blocks[1];
    const btn = tab.querySelector('.collapsible-trigger');
    const content = tab.querySelector('.collapsible-content');

    if (btn && content) {
      btn.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      content.classList.add('is-open');
      content.style.height = content.scrollHeight + 'px';
    }
  }

});



//  <!-- JavaScript for Tab Switching and Conversion -->
//     <script>
//       // Select all the cells that have measurement data.
//       const measurementCells = document.querySelectorAll('#sizeTable tbody td[data-inch]');

//       // Function to switch between inches and cm
//       function switchTab(unit) {
//         if (unit === 'cm') {
//           document.getElementById('inchesTab').classList.remove('active');
//           document.getElementById('cmTab').classList.add('active');
//           convertToCm();
//         } else {
//           document.getElementById('cmTab').classList.remove('active');
//           document.getElementById('inchesTab').classList.add('active');
//           resetToInches();
//         }
//       }

//       // Function to convert and display values in CM
//       function convertToCm() {
//         const inchToCm = 2.54;
//         measurementCells.forEach(cell => {
//           // Always get the original inch value from the 'data-inch' attribute
//           const inchValue = parseFloat(cell.getAttribute('data-inch'));
//           if (!isNaN(inchValue)) {
//             // Calculate CM and update the displayed text
//             cell.textContent = (inchValue * inchToCm).toFixed(1); // Rounded to 1 decimal place
//           }
//         });
//       }

//       // Function to reset the display to the original inch values
//       function resetToInches() {
//         measurementCells.forEach(cell => {
//           // Simply set the displayed text back to the original 'data-inch' value
//           cell.textContent = cell.getAttribute('data-inch');
//         });
//       }
//     </script>
  
     
// <script>
// document.addEventListener('DOMContentLoaded', function () {
//   const productLinks = document.querySelectorAll('.grid-product__link[data-hover-images]');

//   productLinks.forEach(link => {
//     // Split the image URLs string into an array
//     const imageUrls = link.dataset.hoverImages.split('||');
//     const mainImage = link.querySelector('[data-main-product-image]');
    
//     // Skip if there's only one image or the main image can't be found
//     if (imageUrls.length <= 1 || !mainImage) {
//       return;
//     }
    
//     const originalSrc = imageUrls[0];
//     let hoverTimeout;
//     let imageIndex = 1; // Start with the second image

//     const startImageSequence = () => {
//       // Set the image src to the next URL in the array
//       if (imageUrls[imageIndex]) {
//         // Change the src attribute to swap the image
//         mainImage.src = imageUrls[imageIndex];
//         imageIndex++;
        
//         // If there are more images, set a timeout for the next one
//         if (imageUrls[imageIndex]) {
//           hoverTimeout = setTimeout(startImageSequence, 1000); // 1-second interval
//         }
//       }
//     };

//     link.addEventListener('mouseenter', () => {
//       // Clear any previous timer
//       clearTimeout(hoverTimeout);
//       imageIndex = 1; // Reset to the second image
      
//       // Start the image swapping sequence
//       startImageSequence();
//     });

//     link.addEventListener('mouseleave', () => {
//       // Stop the sequence
//       clearTimeout(hoverTimeout);
      
//       // Reset to the original, featured image
//       mainImage.src = originalSrc;
//     });
//   });
// });
// </script>

// {% comment %} <script>
//   // Get the element
// const myElement = document.getElementById('size-fit');

// // Replace all &nbsp; with a regular space or empty string
// myElement.innerHTML = myElement.innerHTML.replace(/&nbsp;/g, ' ');

// // Or to remove it completely
// myElement.innerHTML = myElement.innerHTML.replace(/&nbsp;/g, '');
// </script> {% endcomment %}

// {% comment %} bootstrap 5 js {% endcomment %}

//  {% comment %} Colleciton image swap code for 4 images starts here  {% endcomment %}

// <script>

// document.addEventListener('mouseenter', function(event) {
//   const gallery = event.target.closest('.product-image-gallery');
//   if (!gallery) return;

//   // Stop any previous animations on this gallery
//   if (gallery.cycleInterval) {
//     clearInterval(gallery.cycleInterval);
//   }
  
//   const images = gallery.querySelectorAll('.product-gallery-image');
//   if (images.length <= 1) return;

//   let currentIndex = 0;
  
//   // Initially, make sure only the first image is active
//   images.forEach((img, index) => img.classList.toggle('is-active', index === 0));

//   gallery.cycleInterval = setInterval(() => {
//     images[currentIndex]?.classList.remove('is-active');
//     currentIndex = (currentIndex + 1) % images.length;
//     images[currentIndex]?.classList.add('is-active');
//   }, 2000); // Changed from 800ms to 2000ms (2 seconds) between image changes

// }, true); // Use capture phase to handle events reliably

// document.addEventListener('mouseleave', function(event) {
//   const gallery = event.target.closest('.product-image-gallery');
//   if (!gallery || !gallery.cycleInterval) return;

//   // Stop the animation
//   clearInterval(gallery.cycleInterval);
//   gallery.cycleInterval = null;
  
//   const images = gallery.querySelectorAll('.product-gallery-image');
//   if (images.length <= 1) return;
  
//   // Reset to show only the first image
//   images.forEach((img, index) => {
//     img.classList.toggle('is-active', index === 0);
//   });
// }, true);
// </script>

// <!-- Buy now button display none when preorder is there is in variant metafield -->

//     <script>
//   document.addEventListener('DOMContentLoaded', function() {
//     // A map of variant IDs to their preorder metafield value, created by Liquid
//     const variantPreorderMap = {
//       {% for variant in product.variants %}
//         "{{ variant.id }}": "{{ variant.metafields.custom.preorder_value }}",
//       {% endfor %}
//     };

//     // The elements we need to work with
//     const buyButton = document.getElementById('prouductpagebuybutton');
//     const variantSelector = document.querySelector('[name="id"]');

//     // A function to check the selected variant and toggle the button
//     const toggleBuyButton = () => {
//       if (!buyButton || !variantSelector) {
//         return; // Exit if elements aren't found
//       }

//       const selectedVariantId = variantSelector.value;
//       const preorderStatus = variantPreorderMap[selectedVariantId];

//       // If the metafield value is exactly "Preorder", hide the button. Otherwise, show it.
//       if (preorderStatus === 'Preorder') {
//         buyButton.style.display = 'none';
//       } else {
//         buyButton.style.display = 'block';
//       }
//     };

//     // Add an event listener to run the check whenever the variant changes
//     if (variantSelector) {
//       variantSelector.addEventListener('change', toggleBuyButton);
//     }

//     // Run the check once on page load for the default selected variant
//     toggleBuyButton();
//   });
// </script>
    
// <!-- stock-scaracity display none when preorder is there is in variant metafield -->
//     <script>
//   document.addEventListener('DOMContentLoaded', function() {
//     // 1. Create a map of variant IDs to their preorder metafield value using Liquid.
//     const variantPreorderMap = {
//       {% for variant in product.variants %}
//         "{{ variant.id }}": "{{ variant.metafields.custom.preorder_value }}",
//       {% endfor %}
//     };

//     // 2. Get the elements from the page.
//     const stockScarcityElement = document.querySelector('.stock-scaracity');
//     const variantSelector = document.querySelector('[name="id"]');

//     // 3. Define a function to toggle the element's visibility.
//     const toggleStockScarcity = () => {
//       // Exit if the required elements don't exist on the page.
//       if (!stockScarcityElement || !variantSelector) {
//         return;
//       }

//       const selectedVariantId = variantSelector.value;
//       const preorderStatus = variantPreorderMap[selectedVariantId];

//       // If the metafield value is "Preorder", hide the element. Otherwise, show it.
//       if (preorderStatus === 'Preorder') {
//         stockScarcityElement.style.display = 'none';
//       } else {
//         stockScarcityElement.style.display = 'block'; // Or 'flex', 'inline-block', etc.
//       }
//     };

//     // 4. Listen for changes on the variant selector.
//     if (variantSelector) {
//       variantSelector.addEventListener('change', toggleStockScarcity);
//     }

//     // 5. Run the check on initial page load.
//     toggleStockScarcity();
//   });
// </script>

//     <!-- max inventory hide on preorder -->

// <script>
//   document.addEventListener('DOMContentLoaded', () => {
//     // --- Configuration ---
//     const VARIANT_SELECTOR = 'input[name="id"], select[name="id"]';
//     const PRODUCT_JSON_SELECTOR = '[data-product-json], script[id^="ProductJson-"]';
//     const MESSAGE_SELECTOR = '.max_inv_msg';
//     // --- End Configuration ---

//     const form = document.querySelector('product-form') || document.querySelector('form[action="/cart/add"]');
//     if (!form) return;

//     const variantInput = form.querySelector(VARIANT_SELECTOR);
//     const messageElement = document.querySelector(MESSAGE_SELECTOR);
//     const productJsonScript = document.querySelector(PRODUCT_JSON_SELECTOR);

//     if (!variantInput || !messageElement || !productJsonScript) {
//       console.warn('Could not find all required elements for the inventory message logic.');
//       return;
//     }

//     const productData = JSON.parse(productJsonScript.textContent);

//     const toggleMessageVisibility = () => {
//       const selectedVariantId = variantInput.form.querySelector('[name="id"]:checked, [name="id"] option:checked').value;
//       const currentVariant = productData.variants.find(v => v.id == selectedVariantId);

//       if (!currentVariant) return;
      
//       const isPreorder = currentVariant.metafields?.custom?.preorder_value === 'Preorder';

//       // Add or remove the 'is-hidden' class based on the condition
//       messageElement.classList.toggle('is-hidden', isPreorder);
//     };

//     // Run when the variant selector changes
//     form.addEventListener('change', toggleMessageVisibility);
    
//     // Run once on page load for the initial state
//     toggleMessageVisibility();
//   });
// </script>

//  {% comment %} Colleciton image swap code for 4 images ends here  {% endcomment %}

// <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js" integrity="sha384-MrcW6ZMFYlzcLA8Nl+NtUVF0sA7MsXsP1UyJoMp4YLEuNSfAP+JcXn/tWtIaxVXM" crossorigin="anonymous"></script>


// {% comment %} PDP page tab auto open 2nd tab {% endcomment %}
// <script>
//   document.addEventListener('DOMContentLoaded', function() {
//     // 1. Select all elements with the class 'fjbxnv' under the main parent
//     const allFjbxnvBlocks = document.querySelectorAll('.product-block-custom-style .fjbxnv');

//     // 2. Check if there is at least a second block to avoid errors
//     if (allFjbxnvBlocks.length >= 2) {
//         // 3. Get the second block (index is 1 because counting starts from 0)
//         const secondBlock = allFjbxnvBlocks[1];

//         // 4. Find the button and the content area inside the second block
//         const triggerButton = secondBlock.querySelector('.collapsible-trigger');
//         const contentDiv = secondBlock.querySelector('.collapsible-content');

//         // 5. Check if both the button and content were found
//         if (triggerButton && contentDiv) {
//             // 6. Add the 'is-open' class to both elements
//             triggerButton.classList.add('is-open');
//             contentDiv.classList.add('is-open');

//             // 7. Set the aria-expanded attribute for accessibility
//             triggerButton.setAttribute('aria-expanded', 'true');

//             // 8. Set the height of the content to make it visible
//             // We use scrollHeight to get the full height of the content
//             contentDiv.style.height = contentDiv.scrollHeight + 'px';
//         }
//     }
// });
// </script>